import React from 'react'
import dayjs from 'dayjs'
import 'dayjs/locale/fr'
import { Dialog } from 'components/ui'
import {
    getAppointmentStatusMeta,
    getStatusBadgeStyle,
} from 'constants/appointmentStatus.constant'
import { getDayAppointments } from './calendarDayDetails'

const CalendarDayDetailsDialog = ({ date, events, onClose, onEventClick }) => {
    const appointments = getDayAppointments(events, date)
    return (
        <Dialog
            isOpen={Boolean(date)}
            onClose={onClose}
            onRequestClose={onClose}
            width={620}
            aria={{ labelledby: 'calendar-day-details-title' }}
            contentClassName="flex max-h-[85vh] flex-col"
        >
            <div className="shrink-0 border-b border-gray-200 pb-4 pr-8 dark:border-gray-700">
                <h5 id="calendar-day-details-title" className="capitalize">
                    {date
                        ? dayjs(date).locale('fr').format('dddd D MMMM YYYY')
                        : ''}
                </h5>
                <p className="mt-1 text-sm text-gray-500">
                    {appointments.length} rendez-vous
                </p>
            </div>
            <div className="min-h-0 overflow-y-auto overscroll-contain py-4">
                {appointments.length ? (
                    <ul className="space-y-3">
                        {appointments.map((event) => {
                            const status = getAppointmentStatusMeta(event)
                            const color = event.eventColor || status.color
                            return (
                                <li key={event.id || event._id}>
                                    <button
                                        type="button"
                                        className="block w-full rounded-lg border border-gray-200 border-l-4 bg-white p-3 text-left transition-colors hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 dark:border-gray-600 dark:bg-gray-800 dark:hover:bg-gray-700"
                                        style={{ borderLeftColor: color }}
                                        onClick={(clickEvent) =>
                                            onEventClick(event, clickEvent)
                                        }
                                    >
                                        <span className="mb-2 flex flex-wrap items-center justify-between gap-2">
                                            <span className="text-sm font-semibold text-gray-800 dark:text-gray-100">
                                                {event.allDay
                                                    ? 'Toute la journée'
                                                    : `${dayjs(
                                                          event.start
                                                      ).format('HH:mm')}${
                                                          event.end
                                                              ? ` – ${dayjs(
                                                                    event.end
                                                                ).format(
                                                                    'HH:mm'
                                                                )}`
                                                              : ''
                                                      }`}
                                            </span>
                                            <span
                                                className="rounded px-2 py-1 text-xs font-medium"
                                                style={getStatusBadgeStyle(
                                                    color
                                                )}
                                            >
                                                {status.label}
                                            </span>
                                        </span>
                                        <span className="block break-words text-sm leading-relaxed text-gray-800 dark:text-gray-100">
                                            {event.title}
                                        </span>
                                        {event.props?.motif && (
                                            <span className="mt-1 block break-words text-xs text-gray-500">
                                                {event.props.motif}
                                            </span>
                                        )}
                                    </button>
                                </li>
                            )
                        })}
                    </ul>
                ) : (
                    <p className="py-6 text-center text-sm text-gray-500">
                        Aucun rendez-vous pour cette journée.
                    </p>
                )}
            </div>
            <div className="shrink-0 border-t border-gray-200 pt-4 text-right dark:border-gray-700">
                <button
                    type="button"
                    onClick={onClose}
                    className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-semibold hover:bg-gray-50 dark:border-gray-600 dark:hover:bg-gray-700"
                >
                    Fermer
                </button>
            </div>
        </Dialog>
    )
}

export default CalendarDayDetailsDialog
